export const TIMEOUT = {
  withAction: 7000,
  withoutAction: 4000,
} as const

export const ERROR = {
  message: 'Произошла ошибка. Попробуйте обновить страницу',
  actionText: 'Обновить',
  handleAction: () => {
    if (typeof window !== 'undefined') {
      window.location.reload()
    }
  },
} as const

export const EVENTS = {
  open: 'snackbar:open',
  close: 'snackbar:close',
  created: 'snackbar:created',
  checkCreated: 'snackbar:check-created',
} as const
